//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { testing, testingMessage, passcode } from '~/testing.config'
import AuthenticatePasscode from '~sdp-components/Authentication/AuthenticatePasscode'
import SelectionsMixin from '~/mixins/SelectionsMixin'
import Header from '~sdp-components/Header/Header'
import Navigation from '~/components/Navigation'
import Footer from '~sdp-components/Footer/Footer'
import Columns from '~sdp-components/PageElements/Columns'
import Column from '~sdp-components/PageElements/Column'
import ContentButton from '~sdp-components/PageElements/ContentButton.vue'
import Dropdown from '~sdp-components/PageElements/Dropdown'
import QlikSelectedFilterPills from '~sdp-components/Qlik/QlikSelectedFilterPills'
import QlikCollapsableFilterContainer from '~sdp-components/Qlik/QlikCollapsableFilterContainer'
import QlikCollapsableFilter from '~sdp-components/Qlik/QlikCollapsableFilter'
import PlusMinusIcon from '~sdp-components/Icons/PlusMinusIcon'
import QlikFilter from '~sdp-components/Qlik/QlikFilter'
import Square from '~sdp-components/PageElements/Square'
import Heading from '~sdp-components/PageElements/Heading'
import metricsDef from '~/definitions/display-metrics'

export default {
  name: 'MetricLayout',
  components: {
    AuthenticatePasscode,
    Header,
    Navigation,
    Footer,
    Columns,
    Column,
    ContentButton,
    Dropdown,
    QlikSelectedFilterPills,
    QlikFilter,
    QlikCollapsableFilterContainer,
    QlikCollapsableFilter,
    PlusMinusIcon,
    Square,
    Heading,
  },
  mixins: [SelectionsMixin],
  data() {
    return {
      incorrectPasscodeMessage: undefined,
      selectedMetricCode: '',
      sessionObject: null,
      hypercubeValues: null,
      showMetricDomainsFilter: true,
      showSchoolFilters: false,
      showUnscoredMetrics: true,
      tourSteps: [
        {
          target: '#main-title',
          content:
            'Welcome to the SPREE — Metric page. Here you can investigate performance for specific SPREE metrics.',
          params: { enableScrolling: true },
          offset: -400,
        },
        {
          target: '#main-content-side',
          content:
            'Data on this page summarizes specific metrics, which is displayed above the data visualizations. A metric is automatically selected by default.',
          params: { enableScrolling: true },
          offset: -400,
        },
        {
          target: '#main-content-side',
          content:
            'In the area below you can view charts, tables, and maps related to the selected metric.',
          params: { enableScrolling: true },
          offset: -400,
        },
        {
          target: '#main-metric-filter-panel',
          content:
            'To select a new metric, click the + button next to the metric in the "Select a metric" panel. Here, you can scroll through a list of metrics or type in key words to search. Additionally, click on "Domain" to view options that can help narrow down the list of metrics.',
          params: { enableScrolling: true },
          offset: -200,
        },
        {
          target: '#main-tour-button',
          content: 'Press here to take this tour again.',
          params: { enableScrolling: true },
          offset: -400,
        },
      ],

      tourCallbacks: {
        onSkip: () => this.$store.dispatch('tour/initialize_metric'),
        onFinish: () => this.$store.dispatch('tour/initialize_metric'),
      },
    }
  },
  computed: {
    authenticated() {
      return this.$store.state.authenticated
    },
    bannerMessage() {
      return testing && testingMessage ? testingMessage : undefined
    },
    print() {
      return this.$route.query?.print === 'true' || false
    },
    metricTextMap() {
      const obj = {}
      this.hypercubeValues?.metricCode.forEach(({ text: code }, index) => {
        if (this.hypercubeValues?.metricText[index].text) {
          obj[code] = this.hypercubeValues?.metricText[index].text
        }
      })
      return obj
    },
    selectedMetricText() {
      return this.metricTextMap[this.selectedMetricCode]
    },
  },
  async created() {
    // await this.$qlik.selectFieldValues('flag_scored', 1)
    await this.toggleUnscoredMetrics()
    await this.fetchMetricObjects()
  },
  mounted() {
    if (this.$store.state.tour.initialize_metric && this.authenticated)
      this.launchTour()
  },
  /**
   * Remove field values that we don't want to carry to other pages
   */
  async destroyed() {
    const fieldsToClear = [
      'metric_code',
      'metric_label',
      'domain_code',
      'domain',
      'flag_scored',
    ]
    const engine = await this.$qlik.engine
    let field
    fieldsToClear.forEach(async (fieldName) => {
      field = await engine.getField(fieldName)
      await field.clear()
    })
  },
  methods: {
    async checkPasscode(_passcode) {
      const passcodeValid = _passcode === passcode
      await this.$store.dispatch('set_authenticated', passcodeValid)
      this.incorrectPasscodeMessage = passcodeValid
        ? undefined
        : 'Incorrect password, please try again.'
    },
    async fetchMetricObjects() {
      if (this.$store.state.persistent_variables?.metric_code) {
        this.selectedMetricCode = this.$store.state.persistent_variables?.metric_code
        await this.$qlik.setVariableValueByName(
          'v_option_metric',
          this.selectedMetricCode
        )
      } else {
        this.selectedMetricCode = await this.$qlik.getVariableValueByName(
          'v_option_metric'
        )
        this.$store.commit('set_persistent_variable', {
          key: 'metric_code',
          value: this.selectedMetricCode,
        })
      }
      this.sessionObject = await this.$qlik.generateHypercubeObjectFromDef(
        metricsDef
      )

      this.sessionObject.on('changed', this.update)
      this.update()
    },
    async update() {
      if (this.sessionObject) {
        this.hypercubeValues = await this.$qlik.getValuesFromHypercubeObject(
          this.sessionObject
        )
        // when changing list of metrics check whether the current metric is still available
        // if not select the one at the top of the list
        if (
          this.hypercubeValues.metricCode &&
          this.hypercubeValues.metricCode.filter(
            ({ text }) => text === this.selectedMetricCode
          ).length === 0
        ) {
          await this.handleMetricSelection(
            this.hypercubeValues.metricCode[0].text
          )
        }
      }
    },
    async handleMetricSelection(value) {
      await this.$qlik.setVariableValueByName('v_option_metric', value)
      this.$store.commit('set_persistent_variable', {
        key: 'metric_code',
        value,
      })
      this.selectedMetricCode = value
    },
    async toggleUnscoredMetrics() {
      this.showUnscoredMetrics = !this.showUnscoredMetrics
      if (!this.showUnscoredMetrics) {
        await this.$qlik.selectFieldValues('flag_scored', 1)
      } else {
        await this.$qlik.clearField('flag_scored')
      }
    },
    launchTour() {
      this.$tours.mainTour.start()
    },
  },
}
